import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType,
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { imagesEdit_template } from "../components/templates/imagesEdit_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class images_edit extends vnModule_knockoutJS {
    protected editTemplate: imagesEdit_template;
    protected pagination: pagination_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName() {
        return "images_edit";
    }

    public buildContent(): Array<Element> {
        this.editTemplate = new imagesEdit_template("edit", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Images List");

        return [this.editTemplate.build()];
    }

    public fillPage(): void {
        this.getData();
    }

    protected getData() {
        this.loadingIn(this.editTemplate.builtTemplate);
        let brandId = this.getVnAppZone().app.params.idBrand;
        let imageId = this.getVnAppZone().app.params.id || 0;
        let usrReq_url: string = `/api/brand/${brandId}/images/get/${imageId}/`;
        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON(this.editTemplate.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetData;
        this.XHRHdl.execute();

        if (imageId === 0) {
            this.editTemplate.generateDropzone({});
            this.loadingOut(this.editTemplate.builtTemplate);
        }
    }

    protected onGetData(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.setUpForm(responseParsed.data);
            });
            obj.loadingOut(obj.editTemplate.builtTemplate);
        };
    }

    public setUpForm(data): void {
        this.editTemplate.setHasAccessIsUnderEmbargo(data.hasAccessIsUnderEmbargo);
        this.editTemplate.setPermissions(data.permissions);

        if (data.image && data.image.id) {
            let idPrimaryTag =
                data.image.details && data.image.details !== null && data.image.details.idPrimaryTag !== null
                    ? data.image.details.idPrimaryTag
                    : null;


            this.editTemplate.setId(data.image.id);
            this.editTemplate.setName(data.image.name);
            this.editTemplate.setDescription(data.image.description);
            this.editTemplate.setCaption(data.image.caption);
            this.editTemplate.setUrl(data.image.url);
            this.editTemplate.setLength(data.image.length);
            this.editTemplate.setFileSize(data.image.fileSize);
            this.editTemplate.setSizeHuman(data.image.fileSize);
            this.editTemplate.setIsAiEnhanced(data.image.isAiEnhanced);
            this.editTemplate.setHeight(data.image.height);
            this.editTemplate.setWidth(data.image.width);
            this.editTemplate.setRatio(data.image.ratio);
            this.editTemplate.setMimeType(data.image.mimeType);
            this.editTemplate.setDateCreated(data.image.dateCreated);
            this.editTemplate.setDateUpdated(data.image.dateUpdated);
            this.editTemplate.setAltText(data.image.altText);
            this.editTemplate.setDetails(data.image.details !== null ? data.image.details : null);
            this.editTemplate.setLockItem(true);
            this.editTemplate.generateDropzone(data.image);
            
            if (data.image.imageTags) {
                this.editTemplate.setSelectedTags(data.image.imageTags);
            }
            this.editTemplate.setIdPrimaryTag(idPrimaryTag);
            this.editTemplate.setIsUnderEmbargo(data.image.isUnderEmbargo);
        }
        this.editTemplate.setImageDescription(data.image.description);
        this.editTemplate.setImageCaption(data.image.caption);
    }

    protected edit(id) {
        page("/brand/" + this.getVnAppZone().app.params.idBrand + "/images/edit/" + id);
    }

    public getSavePostData() {
        const vm = this.editTemplate.getTemplateViewModel();

        // edit one at a time
        if (vm.id()) {
            return [{
                id: vm.id(),
                description: this.editTemplate.imageDescriptionEditor.getData(),
                details: vm.details(),
                height: vm.height(),
                mimeType: vm.mimeType(),
                ratio: vm.ratio(),
                fileSize: vm.fileSize(),
                name: vm.name(),
                altText: vm.altText(),
                url: vm.url(),
                width: vm.width(),
                imageTagIds: vm.selectedTags().map(({ tag }) => tag.id),
                idPrimaryTag: vm.idPrimaryTag(),
                isUnderEmbargo: vm.isUnderEmbargo(),
                isAiEnhanced: vm.isAiEnhanced(),
                caption: this.editTemplate.imageCaptionEditor.getData(),
            }];
        } else {
            // edit many at a time when uploading.
            return vm.images().map((image) => ({
                ...image,
                id: null,
                description: this.editTemplate.imageDescriptionEditor.getData(),
                imageTagIds: vm.selectedTags().map(({ tag }) => tag.id),
                idPrimaryTag: vm.idPrimaryTag(),
                isUnderEmbargo: vm.isUnderEmbargo(),
                caption: this.editTemplate.imageCaptionEditor.getData(),
                fileReference: null
            }));

        }
    }

    protected save() {
        this.loadingIn(this.editTemplate.builtTemplate);

        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/images/save";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.getSavePostData())]);
        let XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSave;
        XHRHdl.execute();
    }

    protected onSave(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(
                    vn_app_zone_notification.TYPE_SUCCESS,
                    "Image saved successfully!",
                );
                obj.redirectToListPage();
            });
            obj.loadingOut(obj.editTemplate.builtTemplate);
        };
    }

    protected getUploadUrl(): string {
        return "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/images/upload";
    }

    protected goBack() {
        let previousUrl = this.loadPreviousPage(window.location.href);
        if (previousUrl) {
            page.redirect(previousUrl);
        } else {
            page.redirect("/brand/" + this.getVnAppZone().app.params.idBrand + "/images");
        }
    }

    public redirectToListPage() {
        let previousUrl = this.loadPreviousPage(window.location.href);
        if (previousUrl) {
            page.redirect(previousUrl);
        } else {
            page.redirect("/brand/" + this.getVnAppZone().app.params.idBrand + "/images");
        }
    }

    protected filterSimpleCancel() {
        if (this.XHRHdl) this.XHRHdl.cancelAndReset();
    }

    protected filterSimpleOnChange(idElement) {
        switch (idElement) {
            case "filterTag":
                this.editTemplate.updateSelectedTags();
                break;
            default:
        }
    }

    protected cancelRequest(requestName) {
        if (this.XHRHdls && requestName in this.XHRHdls) {
            this.XHRHdls[requestName].cancelAndReset();
        }
    }

    public getTagsSuggestion(keyword, idSourceElement) {
        this.filterSimpleCancel();
        let subViewModel = {
            filter: {
                keyword: keyword,
                limit: 5,
                tagType: null,
                getSelectable: true,
                getNonSelectable: false,
                imageAndSpecSelectable: false,
            },
        };
        let usrReq_url: string = "/api/brand/" + this.getVnAppZone().app.params.idBrand + "/search/tag/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestion;
        this.XHRHdl.execute();
    }

    protected onGetTagsSuggestion(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags) {
                    obj.editTemplate.setTagFilterAutocomplete(responseParsed.data.tags);
                }
            });
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/images_edit.ts